import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PageWrapper from '../components/layout/PageWrapper';
import PricingToggle from '../components/pricing/PricingToggle';
import PricingCard from '../components/pricing/PricingCard';

const PricingPage: React.FC = () => {
  const [isYearly, setIsYearly] = useState(false);

  const plans = [
    {
      name: 'Basic',
      description: 'Perfect for getting started',
      monthlyPrice: 29,
      yearlyPrice: 290,
      features: [
        'Up to 5 properties',
        'Basic analytics',
        'Email support',
        'Basic listing features'
      ],
      accentColor: 'bg-blue-500',
      popular: false
    },
    {
      name: 'Professional',
      description: 'Ideal for growing businesses',
      monthlyPrice: 79,
      yearlyPrice: 790,
      features: [
        'Up to 25 properties',
        'Advanced analytics',
        'Priority support',
        'Premium listing features',
        'Custom branding',
        'API access'
      ],
      accentColor: 'bg-airbnb-red',
      popular: true
    },
    {
      name: 'Enterprise',
      description: 'For large-scale operations',
      monthlyPrice: 199,
      yearlyPrice: 1990,
      features: [
        'Unlimited properties',
        'Custom analytics',
        '24/7 dedicated support',
        'All premium features',
        'Custom integration',
        'Dedicated account manager',
        'SLA guarantee'
      ],
      accentColor: 'bg-purple-500',
      popular: false
    }
  ];

  return (
    <PageWrapper>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-16">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-4xl font-bold text-gray-900 mb-4"
            >
              Simple, transparent pricing
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-xl text-gray-600 max-w-2xl mx-auto"
            >
              Choose the perfect plan for your property management needs
            </motion.p>
            
            <div className="mt-8">
              <PricingToggle isYearly={isYearly} onToggle={() => setIsYearly(!isYearly)} />
            </div>
          </div>

          <motion.div 
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto"
          >
            {plans.map((plan, index) => (
              <PricingCard
                key={plan.name}
                plan={plan}
                isYearly={isYearly}
                className={plan.popular ? 'md:-mt-4 md:mb-4' : ''}
              />
            ))}
          </motion.div>

          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-16 text-center"
          >
            <p className="text-gray-600">
              All plans include 14-day free trial. No credit card required.
            </p>
          </motion.div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default PricingPage;